import { render, staticRenderFns } from "./MMaterialList.vue?vue&type=template&id=7f7dbc47&"
import script from "./MMaterialList.vue?vue&type=script&lang=ts&"
export * from "./MMaterialList.vue?vue&type=script&lang=ts&"
import style0 from "./MMaterialList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports